import React, { useRef, useEffect, useState } from 'react';
import {
  useStyles 
} from './style';
import { useReactToPrint } from 'react-to-print';
import StatusMessage from '../../components/StatusMessage';
import { Title } from '../../theme/theme';
import { useHistory } from 'react-router';
import { TablePdfPaymentDetail } from '../TablePdfPaymentDetail';
import { TablePdfAddressPaymentInfo } from '../TablePdfAddressPaymentInfo';
import { TablePdfSummaryProducts } from '../TablePdfSummaryProducts';
import { CustomIcon } from '../CustomIcon';
import useQuery from '../../hooks/useQuery';
import { ShippingDetail} from '../../hooks/ShippingDetail';
import { language } from '../../utils/language';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/reducers/index';


export const ComponentToPrint = React.forwardRef((props:any, ref:any) => {

  const homeState: HomeStateType = useSelector((state: RootState) => state.home);

  const [time, setTime] = useState('');
  const payment =  props.purchase.total;
  const subTotal = props.purchase.subtotal;

  const query = useQuery();

  useEffect(() => {

    const newDate = new Date();
    setTime(newDate.toLocaleString() + '');
    
  });



  const classes = useStyles()

  const getStatus = () => {
    if (props.purchase.purchase.cartState === 'procesando_pago')
        return 'pending'
    else if (props.purchase.purchase.cartState === 'pagado')
        return 'success'

    return 'error'
  }

    return (
      <div className={classes.page}>
        <div ref={ref}>
          <div>
            <div className={classes.headDate}>
              <span>
                {time}
              </span>
            </div>
            <div className={classes.comerce}>
              <span>
                {props.purchase.commerce}
              </span>
            </div>    
          </div>
          <div style={{marginBottom: "3rem"}}>
            <StatusMessage status={getStatus()} color={''}/>
          </div>
          <div className={classes.summaryCode}>
            <Title color={props.color}>{`${language[homeState.default_language]["summaryPurchase"]} ${props.purchase.transactionState.refEpayco ? props.purchase.transactionState.refEpayco : ''}`}</Title>
          </div>
          <div>
            <div className={classes.icon}>
                <CustomIcon type='money' color='#000' size='17px'/>
            </div>
            <p className={classes.titleDetail}>
              {language[homeState.default_language]["detailPay"]}
            </p>
          </div>
          <div>
            <TablePdfPaymentDetail props={props.purchase} subTotal={subTotal} payment={payment}/>
            <div>
              <div className={classes.icon}>
                <CustomIcon type='user' color='#000' size='15px'/>
              </div>
                <p className={classes.titleDetail}>
                  {language[homeState.default_language]["information"]}
                </p>
            </div>
            <TablePdfAddressPaymentInfo props={props.purchase} />
          </div>
          {/* <div className={classes.headProducts} style={{ marginTop: '21%' }}>
              <div className={classes.headDate}>
                <span>
                  {time}
                </span>
              </div>
              <div className={classes.comerce}>
                <span >
                  {props.purchase.commerce}
                </span>
              </div>  
          </div> */}
          <TablePdfSummaryProducts props={props.purchase} contactEcommerce={props.contactEcommerce} />
        </div>
      </div>
     
    );
  });

const PurchasePdf = (props:any) => {

  const history = useHistory();
  const refData:any= useRef();

  const handlePrint = useReactToPrint({
    content: () => refData.current,
    onAfterPrint: () => handleClose()
  });

  const handleClose = () => {
    props.onClose()
  }


  useEffect(() => {
    setTimeout(() => {
      handlePrint();
  }, 2500)
    
  }, [refData]) 

  return (
    <div>
        <div style={{display: 'none' }}>
          <ComponentToPrint purchase={props} ref={refData}>
            <div style={{ pageBreakBefore: 'always', marginBottom: '20px' }} /> 
          </ComponentToPrint>
        </div>
    </div>
  ) 
} 

export default PurchasePdf;
